export class LoadRimsPhaseInfos {
  static readonly type = '[Rims] Load rims phase infos';
}
